import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";
import { Link, useParams } from "react-router-dom";

const EcranInstructions = ({ instructions, redirectHome }:{instructions:string, redirectHome?: boolean})=> {

  const {patientId} = useParams<{patientId:string}>();

  let pageURL = '/';
  if (patientId) {
    pageURL = `/praticien/${patientId}/dossier`;
  } else {
    pageURL = '/patient/seances';
  }

  return (
    <div style={{ fontSize:'1.5rem', backgroundColor: 'black', color: 'white', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
      <p>{instructions}</p>
      {redirectHome && <Button  className="mt-4" onClick={() => document.exitFullscreen()} variant={"secondary"} ><Link to={pageURL} className="flex items-center "> <Home className="h-4 w-4 m-4"/> Retourner sur IRON</Link></Button>}
    </div>
  );
};

export default EcranInstructions;
